import script from "./SignOutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignOutPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignOutPage.vue?vue&type=style&index=0&id=3af844a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af844a0"]])

export default __exports__